import React from 'react';
import './ProviderGuidelines.css';

const ProviderGuidelines = () => {
  return (
    <div className="provider-guidelines">
      <div className="guidelines-container">
        <div className="guidelines-header">
          <h1>How to Be a Great Provider</h1>
          <p className="guidelines-subtitle">
            Excellence in practice session guidance starts with understanding your role and responsibilities
          </p>
        </div>

        <div className="guidelines-content">
          <section className="guideline-section">
            <h2>🎯 Setting Clear Expectations</h2>
            <div className="guideline-points">
              <div className="point">
                <h3>Session Preparation</h3>
                <p>Review the practitioner's background and goals before each session. Come prepared with relevant scenarios and feedback strategies tailored to their needs.</p>
              </div>
              <div className="point">
                <h3>Time Management</h3>
                <p>Start and end sessions punctually. Use time efficiently by having a clear structure while remaining flexible to address specific concerns.</p>
              </div>
              <div className="point">
                <h3>Communication Style</h3>
                <p>Establish your coaching approach early. Be direct yet supportive, focusing on actionable feedback rather than general comments.</p>
              </div>
            </div>
          </section>

          <section className="guideline-section">
            <h2>💡 Providing Valuable Feedback</h2>
            <div className="guideline-points">
              <div className="point">
                <h3>Specific and Actionable</h3>
                <p>Instead of "good job," provide specific feedback like "Your opening was engaging because you made direct eye contact and asked a thought-provoking question."</p>
              </div>
              <div className="point">
                <h3>Balance Strengths and Areas for Improvement</h3>
                <p>Highlight what's working well before addressing areas for growth. Use a 2:1 ratio of positive to constructive feedback when possible.</p>
              </div>
              <div className="point">
                <h3>Real-world Applications</h3>
                <p>Connect practice scenarios to real-world situations. Help practitioners understand how their skills transfer to actual interviews or presentations.</p>
              </div>
            </div>
          </section>

          <section className="guideline-section">
            <h2>🤝 Creating a Supportive Environment</h2>
            <div className="guideline-points">
              <div className="point">
                <h3>Psychological Safety</h3>
                <p>Create an environment where practitioners feel safe to make mistakes and ask questions. Normalize the learning process and celebrate progress.</p>
              </div>
              <div className="point">
                <h3>Active Listening</h3>
                <p>Pay attention to both verbal and non-verbal cues. Ask clarifying questions to understand the practitioner's concerns and goals.</p>
              </div>
              <div className="point">
                <h3>Encouragement and Motivation</h3>
                <p>Recognize effort and improvement, not just perfection. Help practitioners build confidence while maintaining realistic expectations.</p>
              </div>
            </div>
          </section>

          <section className="guideline-section">
            <h2>📚 Professional Development</h2>
            <div className="guideline-points">
              <div className="point">
                <h3>Stay Current</h3>
                <p>Keep up with industry trends, interview techniques, and best practices. Continuously update your knowledge to provide relevant guidance.</p>
              </div>
              <div className="point">
                <h3>Adapt Your Approach</h3>
                <p>Different practitioners have different learning styles. Be flexible in your teaching methods and adjust based on individual needs.</p>
              </div>
              <div className="point">
                <h3>Seek Feedback</h3>
                <p>Ask practitioners for feedback on your sessions. Use their input to improve your coaching effectiveness and session quality.</p>
              </div>
            </div>
          </section>

          <section className="guideline-section">
            <h2>⚡ Best Practices for Success</h2>
            <div className="best-practices-grid">
              <div className="practice-item">
                <div className="practice-icon">✅</div>
                <div className="practice-text">
                  <strong>Confirm sessions promptly</strong> - Respond to booking requests within 24 hours
                </div>
              </div>
              <div className="practice-item">
                <div className="practice-icon">🎥</div>
                <div className="practice-text">
                  <strong>Test your technology</strong> - Ensure good audio/video quality before sessions
                </div>
              </div>
              <div className="practice-item">
                <div className="practice-icon">📝</div>
                <div className="practice-text">
                  <strong>Take notes</strong> - Track progress and provide follow-up recommendations
                </div>
              </div>
              <div className="practice-item">
                <div className="practice-icon">🕒</div>
                <div className="practice-text">
                  <strong>Be punctual</strong> - Join sessions 2-3 minutes early to avoid delays
                </div>
              </div>
              <div className="practice-item">
                <div className="practice-icon">💬</div>
                <div className="practice-text">
                  <strong>Use the messaging system</strong> - Share resources and follow up after sessions
                </div>
              </div>
              <div className="practice-item">
                <div className="practice-icon">🎯</div>
                <div className="practice-text">
                  <strong>Focus on goals</strong> - Align each session with the practitioner's objectives
                </div>
              </div>
            </div>
          </section>

          <section className="guideline-section">
            <h2>🚫 What to Avoid</h2>
            <div className="avoid-list">
              <div className="avoid-item">
                <span className="avoid-icon">❌</span>
                <span>Being overly critical or discouraging</span>
              </div>
              <div className="avoid-item">
                <span className="avoid-icon">❌</span>
                <span>Focusing solely on weaknesses without acknowledging strengths</span>
              </div>
              <div className="avoid-item">
                <span className="avoid-icon">❌</span>
                <span>Using sessions for personal stories instead of focused practice</span>
              </div>
              <div className="avoid-item">
                <span className="avoid-icon">❌</span>
                <span>Canceling sessions with less than 4 hours notice (except emergencies)</span>
              </div>
              <div className="avoid-item">
                <span className="avoid-icon">❌</span>
                <span>Providing vague or generic feedback</span>
              </div>
            </div>
          </section>
        </div>

        <div className="guidelines-footer">
          <div className="footer-cta">
            <h3>Ready to Make a Difference?</h3>
            <p>Great providers help practitioners build confidence and achieve their goals. Your expertise and guidance can transform someone's career trajectory.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProviderGuidelines;